module.exports = __webpack_public_path__ + "img/sign_240450750_1.6b888ffb.png";